import * as types from '../actions/types';

const initState = {
    selected: null,
    selecting: false,
    selectingError: null,
    action: false,
    actionError: null
};

export default function AssignmentsReducer (state = initState, action) {
    switch (action.type) {

        case types.ASSIGNMENT_SELECT:
            return {...state, selecting: true, selectingError: null, selected: null };

        case types.ASSIGNMENT_SELECT_SUCCESS:
            return {...state, selecting: false, selectingError: null, selected: action.payload.resource };

        case types.ASSIGNMENT_SELECT_ERROR:
            return {...state, selecting: false, selectingError: action.payload, selected: null };

        case types.ASSIGNMENT_ACTION:
            return {...state, action: true, actionError: null };

        case types.ASSIGNMENT_ACTION_SUCCESS:
            return {...state, action: false, actionError: null };

        case types.ASSIGNMENT_ACTION_ERROR:
            return {...state, action: false, actionError: action.payload };

        default:
            return state;
    }
}
